import { Report1919 } from "../../../components/borrowSystem/Report/Report1919";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report1919Container() {
  const titleName =
    "รายงานการติดตามการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานตามพระราชัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ.2545 และที่แก้ไขเพิ่มเติม ตามแบบ กย.8";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report1919 />
      <Footer />
    </div>
  );
}
